import React, { lazy, useEffect } from 'react'

import Modal from 'react-modal'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { getPage } from './_actions'
import {
    Footer,
    Header,
    Nav,
} from './Components'
import './css/App.scss'

const Home = lazy(() => import(/* webpackChunkName: "Home" */ './Components/Content/Home'))
const IEModal = lazy(() => import(/* webpackChunkName: "IEModal" */ './Components/Global/IEModal'))
const PageView = lazy(() => import(/* webpackChunkName: "PageView" */ './Components/Content/PageView'))

Modal.setAppElement('#root')

const Routes = () => {
    const dispatch = useDispatch()
    const { ie } = useSelector(state => state.content, shallowEqual)
    const { pathname } = useLocation()

    useEffect(() => {
        dispatch(getPage(pathname))
    }, [])

    return (
        <PageWrap>
            <Switch>
                <Route exact path='/' component={Home} />
                <Route exact strict path='/:url*' render={props => <Redirect to={`${props.location.pathname}/`} />} />
                <Route component={PageView} />
            </Switch>
            {ie ? <IEModal /> : ''}
        </PageWrap>
    )
}

export const App = () => (
    <MainPage>
        <Route path='*' component={Header} />
        <Route path='*' component={Nav} />
        <Routes />
        <Route path='*' component={Footer} />
    </MainPage>
)

const PageWrap = styled.main.attrs(({ activeAlert, alertHeight }) => ({
    style: {
        paddingTop: `${activeAlert ? alertHeight + 60 : 60}px`
    }
}))`
    padding-top: ${({ activeAlert }) => activeAlert ? 60 + 40 : 60}px;
    flex: 1;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
`

const MainPage = styled.div`
    display: ${props => props.ie ? 'block' : 'flex'};
    flex-direction: column;
`
